import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig, //寄送，支付接口
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';
import NProgress from 'nprogress';
import viewPhoto from 'src/common/js/viewPhoto';
import $http from '$http';

export default {
    mixins: [services],
    components: {},
    props: {
        value: {
            type: Boolean,
            default: null
        },
    },
    created() {


    },
    data() {
        return {
            loading: false,
            agent: '',
            school: '',
            form: this.getSubmitFormData(),
            netWorkData: this.getSchoolNetWork(),
            SchoolConsigneeList: [],
            ConsigneeList: '', //收货地址
            ConsigneeListName: '', //联系人及电话
            AddDialogVisible: false,
            showData: this.getShowData(), //弹窗传参
            pageIndex: 1,
            pageSize: 10,
            StepId: 1, //1为第一步，2为园所第二步
            stockNum: 0 //使用经销库存发货数736

        }
    },
    methods: {

        getSubmitFormData() {
            return cloneDeep({
                "ClassNum": 0,
                "ClassList": [],
                "OrderPrice": 0,
                "SchoolConsigneeId": 0,
                "OrderId": 0,
                "TimeStamp": 0,
                "PackageId": '',
                "SendMode": 223,
                "PayMode": 222,
                "ListMeetPay": [],
                "GoodsList": [],
                "AgentId": 0,
                "SchoolId": 0,
                "AgentStyle": '',
                "ContractId": 0,
                "ChooseAgentId": '',
                "IsUseAgentStock": "",
                OrderRemark: ''
            });
        },
        // 园所提交信息
        getSchoolNetWork() {
            return cloneDeep({
                "SchoolId": 0,
                "BandWidth": 0,
                "IsSpecilLine": 0,
                "NetworkOperator": [],
                "NetworkType": [],
                "SchoolPics": [],
                "ProveType": 0,
                "ProvePics": [],
                "ContractPices": [],
                "CooperationPics": [],
                "ContractType": 0,
                "Distance": 0,
                "Engineer": 0
            })
        },
        getShowData() {
            return cloneDeep({
                title: '',

            });
        },
        //初始化数据
        initData() {
            this.form = this.getSubmitFormData()
            this.showData = this.getShowData()
            this.school = ""
            this.agent = ""
            this.ConsigneeList = ''
            this.ConsigneeListName = ''
            this.StepId = 1
        },
        show(options) {
            this.initData();
            this.AddDialogVisible = true
            this.showData.title = options.title
            this.GetById(options.OrderId)

        },
        nextStep() {
            this.StepId = 2
            this.showData.title = '园所信息'
        },
        // 返回上一步
        backFn() {
            this.StepId = 1
            this.showData.title = '查看D55/D65订单'
        },

        // 查看图片
        showImgView(img) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{
                    src: img.Url,
                    id: ""
                }]
            });
        },



    },
    computed: {
        materiel() {
            if (this.form.PackageId == 503) {
                return [{
                    ProId: 320,
                    ProName: '65寸在线教室终端',
                    ProNum: this.form.ClassNum
                }]
            } else if (this.form.PackageId == 504) {
                return [{
                    ProId: 333,
                    ProName: '55寸在线教室终端',
                    ProNum: this.form.ClassNum
                }]
            }

        },
        courses() {
            // 课程
            return [{
                ProId: 646,
                ProName: '2018Q2体验课',
                ProNum: 16 * this.form.ClassNum
            }]

        },
        // 上传图片Id
        SchoolPicsCtnId() {
            return 'SchoolPicsCtnId-' + new Date().getTime();
        },
        LicencePicsCtnId() {
            return 'LicencePicsCtnId-' + new Date().getTime();
        },
        CooperationPicsCtnId() {
            return 'CooperationPicsCtnId-' + new Date().getTime();
        },
        EquipPicsCtnId() {
            return 'EquipPicsCtnId-' + new Date().getTime();
        },
    },
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/components/D55OrderView/vm.js